<template>
  <div class="field-lines-pro-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>E = kQ / r²$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 混合仿真：电场线绘制 -->
      <div class="canvas-item simulation">
         <svg width="100%" height="240" viewBox="0 0 400 240">
            <!-- 电荷 q1 -->
            <circle cx="150" cy="120" r="10" :fill="q1 > 0 ? '#ff4757' : '#00d2ff'" />
            <text x="145" y="125" fill="#fff" font-size="12">{{ q1 > 0 ? '+' : '-' }}</text>

            <!-- 电荷 q2 -->
            <circle cx="250" cy="120" r="10" :fill="q2 > 0 ? '#ff4757' : '#00d2ff'" />
            <text x="245" y="125" fill="#fff" font-size="12">{{ q2 > 0 ? '+' : '-' }}</text>

            <!-- 简单的场线示意 (使用 path) -->
            <path v-for="i in 12" :key="'f'+i" :d="getFieldLine(i)" fill="none" :stroke="lineColor" stroke-width="1" opacity="0.4" />
         </svg>

         <div class="hud-top">
            <div class="badge">当前电荷配置: {{ q1 > 0 ? '正' : '负' }} - {{ q2 > 0 ? '正' : '负' }}</div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row center">
               <el-button size="mini" @click="q1 *= -1">切换 q1 极性</el-button>
               <el-button size="mini" @click="q2 *= -1">切换 q2 极性</el-button>
            </div>
         </div>

         <div class="discovery-note" v-latex>
            <p><strong>物理详解：</strong>电场线是为了形象描述电场而引入的假想曲线。其<strong>切线方向</strong>代表场强方向，<strong>疏密程度</strong>代表场强大小。电场线从正电荷（或无穷远）出发，终止于负电荷（或无穷远）。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElectricFieldLinesViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      q1: 1,
      q2: -1
    }
  },
  computed: {
    lineColor() { return '#ffd700'; }
  },
  methods: {
    getFieldLine(i) {
       // Simplified field line paths for visualization
       const angle = (i * 30) * Math.PI / 180;
       if (this.q1 * this.q2 < 0) {
          // Opposite charges: dipole pattern
          return `M 150 120 Q 200 ${120 + Math.sin(angle)*150} 250 120`;
       } else {
          // Same charges: repulsive pattern
          const dx = Math.cos(angle) * 100;
          const dy = Math.sin(angle) * 100;
          return `M 150 120 L ${150-dx} ${120-dy} M 250 120 L ${250+dx} ${120+dy}`;
       }
    }
  }
}
</script>

<style scoped lang="scss">
.field-lines-pro-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #00d2ff; background: rgba(0,210,255,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-item { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; left: 15px; .badge { border: 1px solid #00d2ff; color: #00d2ff; padding: 2px 8px; border-radius: 4px; font-size: 0.7rem; } }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .row.center { display: flex; justify-content: center; gap: 15px; } }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
